import React from "react";
import { Loader } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function LoadingSpinner({ text }) {
  const { t } = useTranslation();
  const displayText = text || t('loading');
  return (
    <div className="flex items-center justify-center gap-2 py-6 text-primary control-text">
      <Loader className="animate-spin h-5 w-5" />
      <span>{displayText}</span>
    </div>
  );
}
